import { isNil } from 'lodash'

import { HStack, HStackProps, Icon, Text } from '@revolut-internal/ui-kit'

import { FCWithChildren } from 'modules/Monitoring/types'

type BreachCellProps = HStackProps & {
  slaBreach?: boolean
  slaBreachValue?: string | number
  showIndicator?: boolean
}

export const BreachCell: FCWithChildren<BreachCellProps> = ({
  slaBreach,
  slaBreachValue,
  showIndicator = true,
  children,
  ...restProps
}) => {
  const hasBreach = Boolean(slaBreach)
  const shouldShowIndicator = showIndicator && hasBreach && !isNil(slaBreachValue)

  return (
    <HStack
      align="center"
      px="s-12"
      space="s-8"
      color={hasBreach ? 'warning' : undefined}
      {...restProps}
    >
      <Text>{children}</Text>
      {shouldShowIndicator && (
        <HStack align="center" space="s-2" flex={1}>
          <Icon name="10/StocksArrowUp" size={10} mb="s-2" />
          <Text>{slaBreachValue}</Text>
        </HStack>
      )}
    </HStack>
  )
}
